import "./static/scss/style.scss"
import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from "react-router-dom"
import App from "./containers/App"
import Home from "./containers/Home";
import Documents from "./containers/Documents";
import AdatkezelesiTajekoztato from "./documents/AdatkezelesiTajekoztato";
import Sütitájékoztató from "./documents/Sütitájékoztató";
import Impresszum from "./documents/Impresszum";
import Aszf from "./documents/Aszf";


const router = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        children: [
            {
                path: "/",
                element: <Home/>
            },
            {
                path: "/tajekoztato",
                element: <Documents/>,
                children: [
                    {
                        path: "adatkezelesi",
                        element: <AdatkezelesiTajekoztato/>
                    },
                    {
                        path: "sutikezelesi",
                        element: <Sütitájékoztató/>
                    },
                    {
                        path: "impresszum",
                        element: <Impresszum/>
                    },
                    {
                        path: "aszf",
                        element: <Aszf/>
                    }
                ]
            }
        ]
    },
], {basename: process.env.PUBLIC_URL});

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <RouterProvider router={router}/>
)